import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Box, Grid} from '@material-ui/core';
import StartButton from '../../../components/atoms/Button/StartButton';
import {inject, observer} from "mobx-react";

const MainTemplate = inject("MainStore")(observer((props) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Box className={classes.textBox}>
                <p>지금부터 당신의</p>
                <p><b>‘연애문제해결능력검사’</b>을</p>
                <p>위한 몇 가지 질문을 시작할게요.</p>
            </Box>
            <Box className={classes.imgBox}>
                <img src={require("../../../style/img/main_img.png")} alt="메인 배경"/>
            </Box>
            <Grid container className={classes.guideBox}>
                <Grid item>
                    <p>*</p>
                </Grid>
                <Grid item>
                    <p>이 검사는 총 4개의 연애 능력 및 유형을 파악하며 진행됩니다.</p>
                    <p>현실적인 문제 해결을 위해 결과 안내 후 선생님과의 실시간</p>
                    <p>대화가 가능합니다.</p>
                </Grid>
            </Grid>
            <Grid container className={classes.redBox}>
                <Grid item>
                    <p >*</p>
                </Grid>
                <Grid item>
                    <p>정확한 진단 결과를 위해 당신의 실제 행동을 체크해주세요.</p>
                </Grid>
            </Grid>

            <StartButton transform={false} width={false} text="진단 시작하기" clickHandler={() => props.MainStore.setIsTest(true)}/>
        </div>
    );
}));

const useStyles = makeStyles({
    root: {
        width: '100%',
        boxSizing: 'border-box',
        padding: '0 5.97%',
        '@media (max-width: 768px)': {
           position: 'fixed',
        },

    },

    textBox: {
        margin: '54.2px auto 0 10px',
        paddingLeft: '14px',
        borderLeft: '3px solid #7e7e7e',
        '& p': {
            fontSize: '19px',
            lineHeight: '1.7'
        },
        '& b': {
            fontWeight: 'bold',
        }
    },
    imgBox: {
        marginTop: '3.6vh',
        width: '293px',
        marginLeft: "10px",

        '& img': {
            width: '89%',
        },
    },
    guideBox: {
        width: (props) =>
            props.width ?
                'calc( 100% - 45px)'
                : '100%',
        marginTop: '3.3vh',
        marginBottom: '1.6vh',

        '& > div:first-child': {
            marginRight: '5px',

            '& p': {
                fontSize: '17px',
            },
        },
        '& p ': {
            fontSize: '12px',
            fontWeight: 400,
            color: '#7f7f7f',
            lineHeight: '1.75',
        },

    },
    redBox: {

        marginBottom: '1.7vh',

        '& > div:first-child': {
            marginRight: '5px',

            '& p': {
                fontSize: '17px',
            },
        },
        '& p ': {
            fontSize: '12px',
            color: 'red',

        },

    },
});

export default MainTemplate;
